module.exports = __webpack_public_path__ + "static/21-02-01_17-27-11_3453-fee750256418aeda14422a68f62db0d7.jpg";